export const locale = {
  dashboard_origin: "Վահանակ",
  menu: "Մենյու",
  get_menu_again: "Կրկին ստանալ մենյուն",
  loading_error: {
    title: "Բեռնման սխալ!",
    message: "Տվյալների բեռնումը հանդիպել է սխալի: Խնդրում ենք կրկին փորձել",
    text: "Կրկին փորձել",
  },
  copy_right: {
    year: "۱۴۰۴",
    text1:
      "Այս համակարգի բոլոր նյութական և ինտելեկտուալ իրավունքները պահպանված են և պատկանում են գովազդային ընկերությանը",
    text2: "Գերազանց ձեռնարկատերեր",
    text3: "Սեփեհր Արադ, ցանկացած պատճենում կհետապնդվի օրենքով:",
  },
  user: "Հարգելի օգտատեր",
  hi: "Ողջույն",
  exit: "Ելք",
  go_to_page: "Գնալ էջ",
  show: "Ցուցադրել",
  until: "մինչև",
  from: "ից",
  page: "էջ",
  notes: "Նշումներ",
  created_at: "Ստեղծման ամսաթիվ",
  registration: "Գրանցում",
  edit_contact: "Խմբագրել կոնտակտը",
  cancel: "Չեղարկել",
  edit: "Խմբագրել",
  delete: "Ջնջել",
  contact_info: "Կոնտակտային տվյալներ",
  add_birthday: "Ավելացնել ծննդյան ամսաթիվ",
  contacts: "Հեռախոսագրքեր",
  last_updated_at: "Վերջին խմբագրում",
  added_to_contact: "Ավելացվել է կոնտակտներին",
  contact_registered: "Ձեր կոնտակտը չի պահպանվել:",
  transaction: "Գործարք",
  write_message: "Գրել հաղորդագրություն",
  note_title: "Նշման վերնագիր",
  create_note: "Ավելացնել նշում",
  are_you_sure_to_delete: "Համոզված եք, որ ուզում եք ջնջել?",
  last_transaction: "Վերջին գործարքները",
  your_balance: "Ձեր մնացորդը",
  no_transaction: "Դեռևս ոչ մի գործարք չի գրանցվել ձեզ համար:",
  increase_balance: "Ավելացնել մնացորդ",
  transaction_list: "Գործարքների ցուցակ",
  withdraw: "Գումար հանել",
  decrease: "Գումար հանել",
  deposit: "Գումար մուտքագրել",
  increase: "Գումար մուտքագրել",
  charge: "Լիցքավորել դրամապանակը",
  refund: "Վերադարձ",
  save: "Պահպանել",
  reload: "Կրկին բեռնել ցուցակը",
  shared: "Համօգտագործված",
  list: "Ցուցակ",
  single_add: "Մեկական ավելացում",
  mass_add: "Զանգվածային ավելացում",
  excel_add: "Excel ավելացում",
  added_successfully: "Հաջողությամբ ավելացվել է",
  error_add_phone: "Հեռախոսահամար ավելացնելու սխալ",
  group: {
    add: "Ավելացնել նոր խումբ",
    delete: "Ջնջել խումբը",
    edit: "Խմբագրել խումբը",
    first: "Խնդրում ենք նախ ավելացնել նոր խումբ:",
  },
  successfully_deleted: "Հաջողությամբ ջնջվել է",
  notification: {
    text: "Օգտատիրոջ ծանուցումներ",
    new: "Նոր հաղորդագրություն",
    messages: "Հաղորդագրություններ",
    events: "Իրադարձություններ",
    no_new_message: "Նոր հաղորդագրություն չկա:",
    show_all: "Ցուցադրել բոլորը",
    no_new_event: "Նոր իրադարձություն չկա:",
    go_to_user: "Գնալ օգտատիրոջը",
    watched: "Դիտվել է",
  },
  locking_for_service: "Ո՞ր ծառայությունն եք փնտրում:",
  service_name: "Մուտքագրեք ձեր ուզած ծառայության անունը...",
  invite: {
    title: "Ներկայացրեք համակարգը ձեր ընկերներին:",
    gift: "Նվեր",
    get: "Ստանալ:",
    phone: "Մուտքագրեք համարը:",
    invite: "Հրավիրել:",
    got_it: "Հասկացա",
    get_gift: "Ստանալ նվեր",
    success: "Ձեր հրավերի հաղորդագրությունը հաջողությամբ ուղարկվել է:",
    wrong_number: "Խնդրում ենք մուտքագրել ճիշտ համար:",
  },
  ticker: {
    text: "Մենք ձեզ հետ ենք ամեն պահ...",
    help: "Աջակցության թիմի հետ կապվելու համար գրանցեք տոմս",
    register: "Գրանցել տոմս",
  },
  package: {
    title: "Ակտիվ փաթեթներ",
    no: "Դուք չունեք ակտիվ փաթեթ:",
    no_limit: "Անսահմանափակ վահանակ",
    day: " օր",
    other: " այլ",
    expiration: "Պիտանելիության ժամկետ ",
    expired: "Ժամկետանց ",
  },
  Loading: {
    Waiting: "Խնդրում ենք սպասել",
    Description: "Մի քանի վայրկյան սպասեք",
  },
  Questions: {
    Yes: "Այո",
    No: "Ոչ",
  },
  Success: {
    Title: "Հաջողություն",
    defaultActionText: "Հասկացա",
  },
  Info: {
    Title: "Տեղեկատվություն",
    defaultActionText: "Հասկացա",
  },
  Warning: {
    Title: "Ուշադրություն",
    defaultActionText: "Հասկացա",
  },
  Error: {
    Title: "Սխալ",
    defaultActionText: "Հասկացա",
  },
  Wallet: {
    Title: "Անբավարար մնացորդ",
    defaultActionText: "Հասկացա",
  },
  ConnectionLost: {
    Title: "Ձեր ինտերնետ կապը ընդհատվել է",
    Subtitle: "Խնդրում ենք ստուգել ձեր ինտերնետ կապը",
    Button: "Կրկին փորձել",
  },
  emoji: "Էմոջի",
  text_suggest_free: "Տեքստի խորհրդատու (անվճար)",
  select_campaign: "Ընտրել արշավ",
  short_link: "Կարճ հղում",
  text_suggest: "Տեքստի խորհրդատու",
  select_emoji: "Ընտրել էմոջի",
  default_text: "Լռելյայն տեքստ",
  emoji_group: {
    "Smileys & Emotion": "Ժպիտներ և զգացմունքներ",
    "People & Body": "Մարդիկ և մարմին",
    "Animals & Nature": "Կենդանիներ և բնություն",
    "Food & Drink": "Սնունդ և խմիչք",
    "Travel & Places": "Ճանապարհորդություն և վայրեր",
    Activities: "Գործունեություններ",
    Objects: "Առարկաներ",
    Symbols: "Խորհրդանիշներ",
    Flags: "Դրոշներ",
  },
  table: {
    index: "Տող",
    title: "Վերնագիր",
    text: "Տեքստ",
    select: "Ընտրել",
    next: "Հաջորդ",
    previous: "Նախորդ",
    rows_per_page: "Տողեր մեկ էջում",
    no_data: "Ցուցադրվող տվյալներ չկան",
    search_placeholder: "Որոնել",
  },
  modal: {
    success: "Հաջողություն",
  },
  actions: {
    remove: "Հեռացնել",
    copyLink: "Պատճենել հղումը",
    operations: "Գործողություններ",
    edit: "Խմբագրել",
    delete: "Ջնջել",
    show: "Ցուցադրել",
    accept: "Հաստատել",
    reject: "Մերժել",
    enable: "Ակտիվացնել",
    download: "Ներբեռնել",
    deactive: "Ապաակտիվացնել",
  },

  shortLink: {
    freeShorten: 'Կարճացրեք ձեր հղումները "անվճար":',
    clickToSelect: "Ընտրելու համար սեղմեք ցանկալի հղման վրա:",
    create: "Ստեղծել կարճ հղում",
    title: "Վերնագիր",
    titleHint: "Խնդրում ենք ավելացնել անուն ձեր կարճ հղման համար:",
    link: "Հղում",
    linkHint: "Մուտքագրեք ցանկալի հղումը:",
    shortenedLink: "Կարճացված հղում",
    clickCount: "Սեղմումների քանակ",
    selectDomain: "Ընտրել դոմեն",
  },
  pagination: {
    next: "Հաջորդ",
    previous: "Նախորդ",
    rowsPerPage: "Տողեր մեկ էջում",
    noData: "Ցուցադրվող տվյալներ չկան",
    search: "Որոնել",
  },
  validation: {
    titleRequired: "Վերնագիրը պարտադիր է",
    minLength4: "Թույլատրվում է նվազագույնը 4 նիշ",
    linkRequired: "Հղումը պարտադիր է",
    mustIncludeHttps: "Պետք է ներառի https://",
    invalidLink: "Խնդրում ենք մուտքագրել վավեր հղում:",
  },
  messages: {
    addedSuccessfully: "Հաջողությամբ ավելացվել է:",
    confirmDeleteShortLink: "Հաստատե՞լ կարճ հղման ջնջումը:",
  },
  inputMenu: {
    text: "Տեքստ",
    selectUserInfo: "Ընտրել օգտատիրոջ տվյալները",
  },
  patternDialog: {
    title: "Ընտրել ձևանմուշ/արշավ",
    change: "Փոխել ձևանմուշ/արշավ",
    createPattern: "Գրանցել նոր ձևանմուշ",
    createCampaign: "Գրանցել նոր արշավ",
    tabs: {
      pattern: "Ընտրել ձևանմուշ",
      campaign: "Ընտրել արշավ",
    },
    empty: "Ձևանմուշ չի գտնվել, նախ գրանցեք ձևանմուշ:",
    columns: {
      id: "Նույնացուցիչ",
      type: "Տեսակ",
      pattern: "Ձևանմուշ",
      static: "Ստատիկ",
      title: "Վերնագիր",
      content: "Տեքստ",
      status: "Կարգավիճակ",
      rejected: "Մերժված",
      approved: "Հաստատված",
    },
    pagination: {
      next: "Հաջորդ",
      prev: "Նախորդ",
      rowsPerPage: "Տողեր մեկ էջում",
      noData: "Ցուցադրվող տվյալներ չկան",
      search: "Որոնել",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "Ընտրված հաղորդագրություն՝",
    REQUIRED_INPUTS: "Պարտադիր մուտքեր՝",
    SELECTED_CAMPAIGN: "Ընտրված արշավ՝",
    CAMPAIGN_ID: "Նույնացուցիչ",
    PRE_NAME: "Նախադիր",
    NAME: "Անուն",
    MIDDLE_NAME: "Միջին անուն",
    LAST_NAME: "Ազգանուն",
    POST_NAME: "Հետդիր",
    ALIAS: "Մականուն",
    COMPANY: "Ընկերություն",
    JOB_TITLE: "Աշխատանքի վերնագիր",
    PHONE: "Հեռախոսահամար",
    BIRTHDAY: "Ծննդյան ամսաթիվ",
    DESCRIPTION: "Նկարագրություն",
  },
  CONTACT_GROUP: {
    LIST: "Ցուցակ",
    ADD: "Ավելացնել",
    SEARCH: "Որոնել",
    INDEX: "Տող",
    ID: "Նույնացուցիչ",
    GROUP_NAME: "Խմբի անուն",
    PARENT: "Ծնող",
    CREATE: {
      GROUP_NAME: "Լռելյայն խմբի անուն",
      PARENT_CATEGORY: "Ծնող կատեգորիա",
      ADD_GROUP: "Ավելացնել խումբ",
      SUCCESS: "Լռելյայն խումբը հաջողությամբ ավելացվել է:",
      ERROR: "Սխալ լռելյայն խումբ ավելացնելիս:",
      SEARCH: "Որոնել",
      TITLE: "Վերնագիր",
      SEARCH_IN_TITLE: "Որոնել վերնագրում",
      FROM: "Սկսած",
      TO: "Մինչև",
      BIRTHDAY_FROM: "Ծննդյան ամսաթիվ սկսած",
      BIRTHDAY_TO: "Մինչև ամսաթիվ",
      ITEMS_PER_PAGE: "Տարրեր մեկ էջում",
      PHONE_COPY: "Պատճենել համարը",
      COPY_PHONE: "Պատճենել համարը",
      DELETE_CONTACT_GROUP: "Ջնջել կոնտակտը խմբից",
      DELETE_FROM_GROUP_ONLY: "Կոնտակտը ջնջվում է միայն այս խմբից",
      DELETE_FROM_ALL_GROUPS: "Կոնտակտը ջնջվում է բոլոր խմբերից",
      USER: "Օգտատեր",
      PHOTO: "Լուսանկար",
      FULL_NAME: "Ամբողջական անուն",
      EMAIL: "Էլ. փոստ",
      PHONE_NUMBER: "Հեռախոսահամար",
      JOB_TITLE_COMPANY: "Աշխատանքի վերնագիր և ընկերություն",
      CREATED_AT: "Ստեղծման ժամանակ",
      PHONEBOOK: "Հեռախոսագիրք",
      ACTIONS: "Գործողություններ",
    },
    TITLE: "Վերնագիր",
    SEARCH_IN_TITLE: "Որոնել վերնագրում",
    FROM: "Սկսած",
    TO: "Մինչև",
    BIRTHDAY_FROM: "Ծննդյան ամսաթիվ սկսած",
    BIRTHDAY_TO: "Մինչև ամսաթիվ",
    ITEMS_PER_PAGE: "Տարրեր մեկ էջում",
    PHONE_COPY: "Պատճենել համարը",
    COPY_PHONE: "Պատճենել համարը",
    DELETE_CONTACT_GROUP: "Ջնջել կոնտակտը խմբից",
    DELETE_FROM_GROUP_ONLY: "Կոնտակտը ջնջվում է միայն այս խմբից",
    DELETE_FROM_ALL_GROUPS: "Կոնտակտը ջնջվում է բոլոր խմբերից",
    USER: "Օգտատեր",
    PHOTO: "Լուսանկար",
    FULL_NAME: "Ամբողջական անուն",
    EMAIL: "Էլ. փոստ",
    PHONE_NUMBER: "Հեռախոսահամար",
    JOB_TITLE_COMPANY: "Աշխատանքի վերնագիր և ընկերություն",
    CREATED_AT: "Ստեղծման ժամանակ",
    PHONEBOOK: "Հեռախոսագիրք",
    ACTIONS: "Գործողություններ",
  },
  GRADUAL: {
    SEND_GRADUAL: "Աստիճանական ուղարկում",
    ALLOWED_HINT: "500-ից ավելի համարներով ուղարկելու համար",
    SEND_GRADUAL_OPTION: "Աստիճանական ուղարկում",
    AFTER_EVERY: "Յուրաքանչյուր",
    SEND_SMS: "SMS ուղարկվի՞:",
    TIME_INTERVAL: "Ժամանակային ընդմիջում",
    SMS_PART: "SMS քանակ",
    SMS_PART_HINT: "Մուտքագրեք ուղարկվող յուրաքանչյուր խմբաքանակի SMS քանակը:",
    COUNT_ERROR:
      "Յուրաքանչյուր խմբաքանակի SMS քանակը չի կարող լինել 500-ից պակաս:",
  },
  HISTORY: {
    CREATE_NEW: "Ստեղծել նոր պատմություն",
    BACK: "Հետ",
    TITLE: "Պատմության վերնագիր",
    STEP: "Քայլ",
    LAST_CALL: "Վերջին զանգի ժամանակ",
    DISCUSSIONS: "Կատարված քննարկումներ",
    REMIND_DATE: "Հիշեցման ամսաթիվ",
    FOLLOWUP: "Հաջորդ զանգի հետևման կետեր",
    SAVE_HISTORY: "Պահպանել պատմությունը",
    INDEX: "Տող",
    SAVED_BY: "Գրանցվել է",
    ACTION: "Կառավարում",
    MORE_INFO: "Ավելի շատ տեղեկություններ մասին",
    CREATE_ERROR: "Սխալ հաճախորդի պատմություն ավելացնելիս:",
  },
  FORMS: {
    SourceNumber: "Աղբյուրի համար",
    DestinationPhone: "Նպատակակետի համար",
    Add: "Ավելացնել",
    SEND_TO_SELECTED_NUMBERS: "Ուղարկել ընտրված համարներին",
    CHANGE_PATTERN_CAMPAIGN: "Փոխել ձևանմուշ/արշավ",
    SendTime: "Ուղարկման ժամանակ",
    SELECTED_MESSAGE: "Ընտրված հաղորդագրություն",
    REQUIRED_INPUTS: "Պարտադիր մուտքեր",
    SELECTED: "Ընտրված",
    ID: "Նույնացուցիչ",
    SEND: "Ուղարկել",
    DATE_REQUIRED: "Ամսաթվի ընտրությունը պարտադիր է:",
    TIME_INTERVAL: "Ժամանակային ընդմիջում",
    TIME_INTERVAL_FROM_PREVIOUS:
      "Ժամանակային ընդմիջում նախորդ հաղորդագրությունից",
    Title: "Վերնագիր",
    LINK: "Հղում",
    LINK_HINT: "any",
    LINK_PLACEHOLDER: "Օրինակ՝[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "Ձեր հղումը կկարճացվի մինչև 14 նիշ և կփոխարինվի (example.ex/any) տեքստում, և յուրաքանչյուր հաղորդագրության համար կուղարկվի նվիրված հղում:",
    Text: "Տեքստ",
    MUST_INCLUDE_PATTERN: "Պետք է ներառի {pattern} արտահայտությունը",
    INVALID_LINK: "Մուտքագրեք վավեր հղում",
  },
  ERRORS: {
    VpnDetectedTitle: "Անջատեք ձեր VPN-ը",
    VpnDetectedSubtitle:
      "Սա թույլ կտա համակարգին ավելի լավ աշխատել և ձեզ ավելի լավ փորձառություն տրամադրել:",
    PhoneIsNotValid: "Հեռախոսահամարը վավեր չէ",
    MaxPhoneLimit: "Դուք չեք կարող ավելացնել ավելի քան 50,000 համար:",
    NoSelectedLineNumber: "Ոչ մի գծի համար ընտրված չէ:",
    INVALID_TIMER: "Մուտքագրեք վավեր ժամանակ",
    PhoneIsNotValid: "Հեռախոսահամարը վավեր չէ",
    MaxPhoneLimit: "Դուք չեք կարող ավելացնել ավելի քան 50,000 համար:",
    NoSelectedLineNumber: "Ոչ մի գծի համար ընտրված չէ:",
    INVALID_TIMER: "Մուտքագրեք վավեր ժամանակ",
    NoAccess: "Դուք մուտք չունեք",
    PleaseBuyAPlane: "Խնդրում ենք գնել փաթեթ",
    NoAccountCharge: "Հաշվի մնացորդը անբավարար է",
    PleaseChargeYourAccount: "Խնդրում ենք լիցքավորել ձեր հաշիվը",
    Unauthorized: "Մուտք չթույլատրված՝ խնդրում ենք կրկին մուտք գործել",
    ServerError: "Սերվերի սխալ է տեղի ունեցել, խնդրում ենք հետագայում փորձել",
    NetworkError: "Ցանցի սխալ՝ խնդրում ենք ստուգել ձեր ինտերնետ կապը",
    InvalidInput: "Մուտքը անվավեր է",
    SessionExpired: "Ձեր սեսիան ժամկետանց է, խնդրում ենք կրկին մուտք գործել",
    TokenInvalid: "Տոկենը անվավեր է",
    VpnDetected: "Ձեր VPN-ը ակտիվ է, խնդրում ենք անջատել այն",
    RequestTimeout: "Ձեր հարցումը ժամկետանց է, խնդրում ենք կրկին փորձել",
    DuplicateEntry: "Այս տարրը արդեն գրանցված է",
  },

  BUTTONS: {
    DELETE_NUMBERS: "Ջնջել համարները",
    ADD_BULK: "Զանգվածային ավելացում",
    FROM_FILE: "Ֆայլից",
    More: "Ավելին",
    BuyAPlane: "Գնել փաթեթ",
    AccountCharge: "Լիցքավորել հաշիվը",
    OK: "Հաստատել",
    Close: "Փակել",
    Cancel: "Չեղարկել",
    Retry: "Կրկին փորձել",
    Login: "Մուտք",
    Logout: "Ելք",
    Save: "Պահպանել",
    Submit: "Ուղարկել",
  },
  GENERAL: {
    row: "Տող",
    id: "Նույնացուցիչ",
    back: "Հետ",
    manage: "Կառավարել",
    SENDING: "Ուղարկվում է",
    RELOAD: "Կրկին բեռնել",
    PRINT: "Տպել",
    DELETE: "Ջնջել",
    SUBMIT: "Ուղարկել",
    SUCCESSFULLY_ADDED: "Հաջողությամբ ավելացվել է",
    RELOAD: "Կրկին բեռնել",
    CANCEL: "Չեղարկել",
    SUCCESSFULLY_DOWNLOADED: "Հաջողությամբ ներբեռնվել է",
    Loading: "Բեռնվում է...",
    NoData: "Տվյալներ չեն գտնվել",
    Welcome: "Բարի գալուստ",
    Profile: "Անձնական էջ",
    Settings: "Կարգավորումներ",
    Wallet: "Դրամապանակ",
    Dashboard: "Վահանակ",
  },

  NOTICES: {
    Attention: "Ուշադրություն",
    MinimumSendWarning:
      '"Նորությունների ուղարկում" աղբյուրի համարով SMS ուղարկելիս նվազագույն քանակը պետք է լինի {{number}}:',
  },
  contactsTags: {
    select_group: "Ընտրել խումբ",
    create_group: "Ստեղծել խումբ",
    search: "Որոնել",
    add_group: "Ավելացնել խումբ",
    enter_group_name: "Մուտքագրեք ցանկալի անունը",
    group_name: "Խմբի անուն",
    cancel: "Չեղարկել",
    edit: "Խմբագրել",
    save: "Պահպանել",
    loading_categories: "Բեռնվում են կատեգորիաները...",
    select_group_and_subgroup: "Ընտրել խումբ և ենթախումբ",
    add_group_with_subgroups: "Ավելացնել խումբը ենթախմբերով",
    add_group_only: "Ավելացնել միայն ընտրված խումբը",
    duplicate_name_error: "Անունը կրկնվում է",
    added_successfully: "Հաջողությամբ ավելացվել է:",
    confirm_delete_group: "Հաստատե՞լ խմբի ջնջումը:",
    deleted_successfully: "Հաջողությամբ ջնջվել է",
    edited_successfully: "Հաջողությամբ խմբագրվել է",
    group_added_successfully: "Ընտրված խմբերը հաջողությամբ ավելացվել են:",
    error_creating_group: "Սխալ լռելյայն խումբ ստեղծելիս",
    create_default_group: "Ստեղծել լռելյայն խումբ",
    select_default_group: "Ընտրել լռելյայն խումբ",
    add_custom_group: "Ավելացնել խումբ անհատական անունով",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "Ավելացնել հեռախոսահամար",
    ADD: "Ավելացնել",
    SHARE_ACCESS:
      "Ընտրելով ստորև բերվածներից որևէ մեկը, կիսվեք ցանկալի մուտքով ուրիշների հետ:",
    SELECT_ACCESS: "Ընտրել մուտք հեռախոսագրքի համար",
    DELETE: "Ջնջել",
    EDIT: "Խմբագրել",
    SEND: "Ուղարկել",
    PERSONS_WITH_ACCESS: "Մուտք ունեցող անձինք",
    REMOVE_ACCESS: "Հեռացնել մուտքը",
    RETURN: "Հետ",
    SAVE_CHANGES: "Պահպանել փոփոխությունները",
    SHARE_CONTACT_BOOK: "Համօգտագործել հեռախոսագիրքը",
    PHONE_VALIDATION: "Մուտքագրեք վավեր հեռախոսահամար",
    SUCCESS_SHARE: "Հեռախոսագիրքը հաջողությամբ համօգտագործվել է:",
    ERROR_SHARE: "Սխալ հեռախոսագիրքը համօգտագործելիս:",
    PHONE_DUPLICATE: "Համարը արդեն մուտքագրված է:",
    CHANGES_SAVED: "Փոփոխությունները հաջողությամբ պահպանվել են:",
    ERROR_SAVING_CHANGES: "Սխալ փոփոխությունները պահպանելիս:",
  },
  CONTACT_SEARCH: {
    SEARCH: "Որոնել",
    ADD_NUMBER: "Ավելացնել համար",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "Մեկ էջում",
    FROM: "Սկսած",
    TO: "Մինչև",
    TOTAL: "Ընդհանուր",
  },
  SUCCESS: {
    DELETED: "Հաջողությամբ ջնջվել է",
    SUCCESS: "Հաջողություն",
  },
  CONFIRM: {
    DELETE_BULK: "Ջնջե՞լ չպահպանված համարները:",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "Պատճենեք ձեր համարները, ապա սեղմեք",
    COPY_LINK: "Պատճենել հղումը",
    COPY_NUMBER: "Պատճենել համարը",
    SEE_PROFILE: "Դիտել անձնական էջը",
  },
  CONTACT_EDIT: {
    EDIT: "Խմբագրել",
    DELETE: "Ջնջել",
  },
  CONTACT_MENU: {
    SHARE: "Համօգտագործել",
    PRINT: "Տպել",
    EXCEL_EXPORT: "Արտահանել Excel",
    DELETE: "Ջնջել",
    SUCCESS_DELETE: "Հաջողությամբ ջնջվել է:",
    ERROR_DELETE: "Սխալ կոնտակտները ջնջելիս:",
  },
  CONTACTS: {
    PREFIX: "Նախադիր",
    NAME: "Անուն",
    MIDDLENAME: "Միջին անուն",
    LASTNAME: "Ազգանուն",
    POSTFIX: "Հետդիր",
    ALIAS: "Մականուն",
    COMPANY: "Ընկերություն",
    JOBTITLE: "Աշխատանքի վերնագիր",
    PHONE: "Հեռախոսահամար",
    PHONE_PLACEHOLDER: "Օրինակ՝ 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "Ավելացնել էլ. փոստ",
    EMAIL: "Էլ. փոստ",
    ADD_ADDRESS: "Ավելացնել հասցե",
    ADDRESS: "Հասցե",
    PROVINCE: "Մարզ",
    CITY: "Քաղաք",
    POSTALCODE: "Փոստային ինդեքս",
    YEAR_OPTIONAL: "Տարի (ընտրովի)",
    MONTH: "Ամիս",
    DAY: "Օր",
    ADD_BIRTHDAY: "Ավելացնել ծննդյան ամսաթիվ",
    ADD_WEBSITE: "Ավելացնել կայք",
    WEBSITE: "Կայք",
    ADD_DATE: "Ավելացնել ամսաթիվ",
    DATE: "Ամսաթիվ",
    CUSTOM_FIELD: "Անհատական դաշտ",
    ADD_CUSTOM_FIELD: "Ավելացնել անհատական դաշտ",
    NOTE: "Նկարագրություն",
    ADD_NOTE: "Ավելացնել նշում",
    HOME: "Տուն",
    WORK: "Աշխատանք",
    OTHER: "Այլ",
    PROFILE: "Անձնական էջ",
    BLOG: "Բլոգ",
    HOMEPAGE: "Գլխավոր էջ",
    TITLE: "Վերնագիր",
    BIRTHDAY_ERROR: "Մուտքագրեք ամսաթիվը ճիշտ",
    YEAR_ERROR: "4 նիշ",
    EMAIL_ERROR: "Մուտքագրեք էլ. փոստը ճիշտ",
    WEBSITE_ERROR: "Մուտքագրեք հղումը ճիշտ (website.com)",
    PHONE_ERROR: "Մուտքագրեք վավեր հեռախոսահամար",
    ADD_HISTORY: "Ավելացնել պատմություն",
    HISTORY_LIST: "Պատմությունների ցուցակ",
    EDIT_CONTACT: "Խմբագրել կոնտակտը",
    SHOW_CONTACT: "Ցուցադրել կոնտակտը",
  },
  MONTHS: {
    FARVARDIN: "Ֆարվարդին",
    ORDIBEHESHT: "Օրդիբեհեշտ",
    KHORDAD: "Խորդադ",
    TIR: "Տիր",
    MORDAD: "Մորդադ",
    SHAHRIVAR: "Շահրիվար",
    MEHR: "Մեհր",
    ABAN: "Աբան",
    AZAR: "Ազար",
    DEY: "Դեյ",
    BAHMAN: "Բահման",
    ESFAND: "Էսֆանդ",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "Ներբեռնել և օգտագործել Excel-ի նմուշային ֆայլը",
    UPLOAD_TITLE: "Վերբեռնել ֆայլ",
    DRAG_DROP_TEXT_PART1: "Վերբեռնելու համար քաշեք և բաց թողեք կամ",
    DRAG_DROP_TEXT_PART2: "սեղմեք այստեղ",
    DRAG_DROP_TEXT_PART3: "",
    FILE_INPUT_LABEL: "Վերբեռնել Excel ֆայլ",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "Հղումը հաջողությամբ պատճենվել է:",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "Սխալ հղումը պատճենելիս:",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "Ընտրել ձևանմուշ/արշավ",
    BUTTON_EDIT_TEXT: "Փոխել ձևանմուշ/արշավ",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "Գրանցել նոր ձևանմուշ",
    REGISTER_NEW_CAMPAIGN: "Գրանցել նոր արշավ",
    CREATE_NEW_HISTORY: "Ստեղծել նոր պատմություն",
    SAVE_HISTORY: "Պահպանել պատմությունը",
    SELECT_GROUP: "Ընտրել խումբ",
    CREATE_GROUP: "Ստեղծել խումբ",
    ADD_GROUP: "Ավելացնել խումբ",
    SAVE: "Պահպանել",
    CREATE_GROUP_SINGULAR: "Ստեղծել խումբ",
    ADD: "Ավելացնել",
    SEND: "Ուղարկել",
    EDIT_PERMISSIONS: "Խմբագրել",
    GO_BACK: "Հետ",
    SAVE_CHANGES: "Պահպանել փոփոխությունները",
    GUIDE: "Ուղեցույց",
    START: "Սկսել",
    EDIT: "Խմբագրել",
    CANCEL: "Չեղարկել",
    AUTO_REFRESH: "Ավտոմատ թարմացում",
    AUTO_REFRESH_SETTINGS: "Ավտոմատ թարմացման կարգավորումներ",
    BACK: "Հետ",
  },
  TABS: {
    SELECT_PATTERN: "Ընտրել ձևանմուշ",
    SELECT_CAMPAIGN: "Ընտրել արշավ",
    LIST: "Ցուցակ",
    ADD: "Ավելացնել",
    ADD_CUSTOM_GROUP: "Ավելացնել խումբ անհատական անունով",
    SELECT_DEFAULT_GROUP: "Ընտրել լռելյայն խումբ",
  },
  NO_DATA: {
    NO_PATTERN: "Ձևանմուշ չի գտնվել, նախ գրանցեք ձևանմուշ:",
  },
  TABLE: {
    ID: "Նույնացուցիչ",
    TYPE: "Տեսակ",
    PATTERN: "Ձևանմուշ",
    STATIC: "Ստատիկ",
    TITLE: "Վերնագիր",
    TEXT: "Տեքստ",
    STATUS: "Կարգավիճակ",
    REJECTED: "Մերժված",
    ACCEPTED: "Ընդունված",
    NEXT_BUTTON: "Հաջորդ",
    PREVIOUS_BUTTON: "Նախորդ",
    ROWS_PER_PAGE_TEXT: "Տողեր մեկ էջում",
    NO_DATA_TEXT: "Ցուցադրվող տվյալներ չկան",
    PLACEHOLDER_SEARCH: "Որոնել",
    MORE_INFO_ABOUT_ITEM: "Ավելի շատ տեղեկություններ {name}-ի մասին",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "Տեքստ",
    SELECT_USER_INFO: "Ընտրել օգտատիրոջ տվյալները",
  },
  TABLE_CONTROLS: {
    COUNT: "Քանակ",
    SEARCH: "Որոնել",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "Լռելյայն խմբի անուն",
    PARENT_CATEGORY: "Ծնող կատեգորիա",
    HISTORY_TITLE: "Պատմության վերնագիր",
    STEP: "Քայլ",
    LAST_CALL_TIME: "Վերջին զանգի ժամանակ",
    NEGOTIATIONS: "Կատարված բանակցություններ",
    REMINDER_TIME: "Հիշեցման ժամանակ",
    FOLLOW_UP_ITEMS: "Հաջորդ զանգի հետևման կետեր",
    GROUP_NAME: "Խմբի անուն",
    SEARCH: "Որոնել",
    TITLE: "Վերնագիր",
    SEARCH_IN_TITLE: "Որոնել վերնագրում",
    FROM: "Սկսած",
    TO: "Մինչև",
    BIRTHDAY_FROM: "Ծննդյան ամսաթիվ սկսած",
    BIRTHDAY_TO: "Մինչև ամսաթիվ",
    COUNT: "Քանակ",
    ADD_PHONE_NUMBER: "Ավելացնել հեռախոսահամար",
  },
  TOAST: {
    Success: "Գործողությունը հաջողությամբ կատարվել է",
    Error: "Սխալ է տեղի ունեցել",
    Warning: "Զգուշացում՝ խնդրում ենք ստուգել մուտքերը",
    AUTO_REFRESH_STARTED: "Ավտոմատ թարմացումը սկսվել է:",
    DEFAULT_GROUP_SUCCESS: "Լռելյայն խումբը հաջողությամբ ավելացվել է:",
    DEFAULT_GROUP_ERROR: "Սխալ լռելյայն խումբ ավելացնելիս:",
    ADD_HISTORY_ERROR: "Սխալ հաճախորդի պատմություն ավելացնելիս:",
    DUPLICATE_NAME: "Անունը կրկնվում է",
    TAG_ADDED_SUCCESS: "Պիտակը հաջողությամբ ավելացվել է:",
    TAG_DELETED_SUCCESS: "Պիտակը հաջողությամբ ջնջվել է",
    TAG_EDITED_SUCCESS: "Պիտակը հաջողությամբ խմբագրվել է",
    GROUPS_ADDED_SUCCESS: "Ընտրված խմբերը հաջողությամբ ավելացվել են:",
    ADD_GROUP_ERROR: "Սխալ լռելյայն խումբ ավելացնելիս:",
    PHONE_COPIED_SUCCESS: "Հեռախոսահամարը պատճենվել է:",
    SUCCESSFULLY_DELETED: "Հաջողությամբ ջնջվել է",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK:
      "Սխալ կոնտակտը հեռախոսագրքից ջնջելիս:",
    SHARE_SUCCESS: "Հեռախոսագիրքը հաջողությամբ համօգտագործվել է:",
    SHARE_ERROR: "Սխալ հեռախոսագիրքը համօգտագործելիս:",
    NUMBER_ALREADY_ADDED: "Համարը արդեն ավելացված է:",
    CHANGES_SAVED_SUCCESS: "Փոփոխությունները հաջողությամբ պահպանվել են:",
    CHANGES_SAVE_ERROR: "Սխալ փոփոխությունները պահպանելիս:",
  },
  HEADERS: {
    GRADUAL_SEND: "Աստիճանական ուղարկում",
    GRADUAL_SEND_HINT: "(500-ից ավելի համարներով ուղարկելու համար)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "Աստիճանական ուղարկում",
    DELETE: "Ջնջել",
    EDIT: "Խմբագրել",
    ADD: "Ավելացնել",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION:
      "Յուրաքանչյուր {time}-ից հետո որքա՞ն հաղորդագրություն ուղարկվի:",
  },
  LABELS: {
    TIME_INTERVAL: "Ժամանակային ընդմիջում",
    MESSAGE_COUNT: "Հաղորդագրությունների քանակ",
  },
  TIME_TYPES: {
    MINUTE: "րոպե",
    HOUR: "ժամ",
    DAY: "օր",
    WEEK: "շաբաթ",
    SECOND: "վայրկյան",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART:
      "Մուտքագրեք ուղարկվող յուրաքանչյուր խմբաքանակի հաղորդագրությունների քանակը:",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT:
      "Յուրաքանչյուր խմբաքանակի հաղորդագրությունների քանակը չի կարող լինել 500-ից պակաս:",
  },
  TABLE_HEADERS: {
    ROW: "Տող",
    TITLE: "Վերնագիր",
    STEP: "Քայլ",
    REMINDER_TIME: "Հիշեցման ժամանակ",
    LAST_CALL_TIME: "Վերջին զանգի ժամանակ",
    RECORDER: "Գրանցող",
    MANAGEMENT: "Կառավարում",
    ID: "Նույնացուցիչ",
    GROUP_NAME: "Խմբի անուն",
    PARENT: "Ծնող",
    CREATED_AT: "Ստեղծվել է",
    IMAGE: "Պատկեր",
    FULL_NAME: "Ամբողջական անուն",
    EMAIL: "Էլ. փոստ",
    PHONE_NUMBER: "Հեռախոսահամար",
    JOB_COMPANY: "Աշխատանքի վերնագիր և ընկերություն",
    CREATION_TIME: "Ստեղծման ժամանակ",
    PHONEBOOK: "Հեռախոսագիրք",
    ACTIONS: "Գործողություններ",
    USER: "Օգտատեր",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "Աղբյուրի համար",
  },
  MODAL: {
    INFO_TITLE: "Ուշադրություն:",
    INFO_MESSAGE_NEWS_NUMBER:
      '"{number}" աղբյուրի համարով SMS ուղարկելիս նվազագույն քանակը պետք է լինի 1000:',
    CONFIRM_DELETE_GROUP: "Հաստատե՞լ խմբի ջնջումը:",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "Նորությունների ուղարկում",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "Համակարգի ուղեցույց",
    ERROR: "Սխալ",
    WARNING: "Զգուշացում",
    SUCCESS: "Հաջողություն",
    CONFIRM: "Հաստատել",
    SELECT_GROUP: "Ընտրել խումբ",
    CREATE_NEW_GROUP: "Ստեղծել նոր խումբ",
    SELECT_GROUP_SUBGROUP: "Ընտրել խումբ և ենթախումբ",
    CREATE_DEFAULT_GROUP: "Ստեղծել լռելյայն խումբ",
    DELETE_CONTACT_FROM_GROUP: "Ջնջել կոնտակտը խմբից",
    DELETE_CONTACT: "Ջնջել կոնտակտը",
    SHARE_PHONEBOOK: "Համօգտագործել հեռախոսագիրքը",
    SYSTEM_GUIDE: "Գովազդային տերմինալի ուղեցույց",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "Մուտքագրեք ցանկալի անունը",
    SELECT_PERMISSIONS: "Ընտրել մուտք հեռախոսագրքի համար {name}:",
    PEOPLE_WITH_ACCESS: "Մուտք ունեցող անձինք",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "Բեռնվում են կատեգորիաները...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "Ավելացնել խումբը ենթախմբերով",
    SELECTED_GROUP_ONLY: "Ավելացնել միայն ընտրված խումբը",
    DELETE_FROM_THIS_GROUP_ONLY: "Կոնտակտը ջնջվում է միայն այս խմբից",
    DELETE_FROM_ALL_GROUPS: "Կոնտակտը ջնջվում է բոլոր խմբերից",
  },
  FILTER_LABELS: {
    ADDRESS: "Հասցե",
    EMAIL: "Էլ. փոստ",
    WEBSITE: "Կայք",
    CUSTOM_FIELD: "Անհատական դաշտ",
    DATE: "Ամսաթիվ",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION:
      "Ընտրելով ստորև բերվածներից որևէ մեկը, կիսվեք ցանկալի մուտքով ուրիշների հետ:",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "Մուտքագրեք վավեր հեռախոսահամար",
  },
  LIST_ITEM_TITLES: {
    DELETE: "Ջնջել",
    EDIT: "Խմբագրել",
    ADD: "Ավելացնել",
    REMOVE_ACCESS: "Հեռացնել մուտքը",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "Արշավի անուն",
    TEXT: "Տեքստ",
    MESSAGE: "Հաղորդագրություն",
    FOR: "Համար",
    SELECT_CAMPAIGN: "Ընտրել արշավ",
    CLICK_ROW: "Սեղմեք ցանկալի տողի վրա:",
    NEW: "Նոր",
    SUBMIT_CAMPAIGN: "Գրանցել արշավ",
    TIME: "Ժամ",
    MESSAGE_COUNT: "Հաղորդագրությունների քանակ",
    PAGE_COUNT: "Ընդհանուր հաղորդագրություն (էջ)",
    PAGE: "Էջ",
    CANCEL_TEXT: "Չեղարկել11",
    TRACKABLE_LINK: "Հետևվող հղում",
    WARNING_TEXT: "Խնդրում ենք ուղղել ընտրված արշավի տեքստ(եր)ը:",
    WARNING_TITLE: "Խնդրում ենք ուղղել ընտրված արշավի վերնագիր(ներ)ը:",
    WARNING_GAP:
      "Խնդրում ենք ուղղել ընտրված արշավի ժամանակային ընդմիջում(ներ)ը:",
    WARNING_OPERATOR: "Խնդրում ենք ուղղել ընտրված արշավի օպերատոր(ներ)ը:",
    MAX_ITEMS_ERROR: "Առավելագույնը 10 տարր կարող է ավելացվել:",
  },
  ADS: {
    LIVE_SMS: "Կենդանի SMS ուղարկում",
    BUY_JOB_DB: "Գնել աշխատանքների տվյալների բազա",
    SMART_LADDER: "Դիվարի գովազդի խելացի սանդղակ",
    JOB_SMS: "SMS ուղարկել աշխատանքներին",
    WEB_DESIGN: "Պատվիրել կայքի դիզայն",
    SEO: "Պատվիրել կայքի SEO",
    MAP_SMS: "SMS ուղարկել քարտեզից",
    GRADUAL_LADDER: "Դիվարի գովազդի աստիճանական սանդղակ",
    SEO_ALT: "Պատվիրել կայքի SEO",
    SITE_SUPPORT: "Կայքի կառավարում և աջակցություն",
    CITY_SMS: "SMS ուղարկել քաղաք և մարզ",
    AUTO_CHAT: "Դիվարի ավտոմատ չատ",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "Կապ WhatsApp-ով",
    TICKET_SUPPORT: "Գրանցել տոմս",
  },
  INCREASE: {
    PAN: "Քարտի համար",
    CVV2: "CVV2",
    MONTH: "Ամիս",
    YEAR: "Տարի",
    PIN2: "Միանգամյա գաղտնաբառ",
    GET_OTP: "Ստանալ միանգամյա գաղտնաբառ",
    PAY: "Վճարել",
    INVALID_PAN: "Քարտի համարը վավեր չէ",
    INVALID_CVV2: "CVV2-ը վավեր չէ",
  },
  WALLET: {
    CustomCharge: "Լիցքավորել դրամապանակը",
    withdrawTitle: "Հանել դրամապանակից",
    transactionListTooltip: "Ձեր գործարքների ցուցակ",
    reloadTooltip: "Կրկին բեռնել",
    withdrawTooltip: "Հանել դրամապանակից",
    AmountLabel: "Կրեդիտ ",
    SelectAmount: "Ընտրել գումար",
    Amount: "Գումար",
    Currency: "Ռիալ",
    GateWay: "Վճարման դարպաս",
    noGateWay: "Դարպաս չի գտնվել",
    Pay: "Վճարել",
    PriceNotInRange: "Գումարը պետք է լինի {min}-ից {max}:",
    ErrorOnRedirectToGateWay: "Սխալ վճարման դարպաս տեղափոխվելիս",
    ErrorGeneral: "Սխալ",
    MinAmountError: "Մուտքագրված գումարը նվազագույնից պակաս է:",
    MinBazarAmountError: "Գումարը չի կարող լինել 10,000 թոմանից պակաս:",
    BazarSuccessInfo:
      "Հաջող վճարման դեպքում ձեր դրամապանակը կլիցքավորվի 1-ից 3 րոպեում:",
    withdrawableBalance: "Հանվող մնացորդ",
    withdrawFee: "Հաշվից հանման վճար՝ 50,000 ռիալ:",
    selectAccount: "Ընտրել հաշիվ",
    addAccount: "Ավելացնել հաշիվ",
    submitWithdraw: "Գրանցել հանում",
    accountRequiredInfo: "Բոլոր տեղեկությունները պարտադիր են:",
    ownerName: "Հաշվի սեփականատիրոջ անուն",
    ownerLastName: "Ազգանուն",
    bankName: "Բանկի անուն",
    accountNumber: "Հաշվի համար",
    cardNumber: "Քարտի համար",
    sheba: "Շեբա համար",
    onlyPersian: "Թույլատրվում են միայն պարսկական տառեր:",
    cardNumberLength: "Քարտի համարի թվանշանները պետք է լինեն 16:",
    shebaLength: "Շեբա համարի թվանշանները պետք է լինեն 24:",
  },
  USER_PICKER: {
    SELECT_USER: "Ընտրել օգտատեր",
    SELECT_USERS: "Ընտրել օգտատերեր",
    SEARCH: "Որոնել",
    PERSON: "Ֆիզիկական անձ",
    COMPANY: "Իրավաբանական անձ",
    ID: "Նույնացուցիչ",
    NAME: "Անուն",
    LASTNAME: "Ազգանուն",
    USERNAME: "Օգտանուն",
    PHONE: "Հեռախոսահամար",
    TYPE: "Օգտատիրոջ տեսակ",
  },
  NEWS: {
    TITLE: "SMS Land-ի նորություններ",
    VIEW_BUTTON: "Դիտել",
    NO_NEWS: "Նոր նորություն չկա:",
    FETCH_ERROR: "Սխալ նորությունները բեռնելիս:",
  },
  MENUS: {
    CONTACT_LIST: "Կոնտակտների ցուցակ",
    FINDPREFIX: "Որոնել նախադիր",
    // Համակարգեր
    TICKET_REGISTRATION: "Տոմսի գրանցում",
    AD_TERMINAL_SYSTEM: "Գովազդային մեծ տերմինալ համակարգ",
    WALLET_TRANSACTIONS: "Դրամապանակի գործարքներ",
    DYNAMIC_QR_SYSTEM: "Դինամիկ QR ստեղծման համակարգ",
    DIVAR_AD_SYSTEM: "Դիվարի գովազդի տեղադրման և կառավարման համակարգ",
    GRAPHIC_DESIGN_SYSTEM: "Գրաֆիկական դիզայնի, տպագրության պատվերի համակարգ",
    DIGITAL_MARKETING_SYSTEM: "Թվային մարկետինգի կառավարման համակարգ",
    BULK_SMS_SYSTEM: "Զանգվածային SMS ուղարկման համակարգ",
    BUSINESS_INFO_SYSTEM: "Երկրի աշխատանքների տվյալների բանկի համակարգ",
    AD_MANAGEMENT_SYSTEM: "Գովազդային գովազդի կառավարման համակարգ",
    GRAPHIC_VIDEO_SERVICES:
      "Գրաֆիկական և վիդեո դիզայնի ծառայությունների համակարգ",
    // QR գործիքներ
    QR_TOOL: "QR գործիք",
    CREATE_DYNAMIC_QR: "Ստեղծել դինամիկ QR",
    QR_MANAGEMENT: "QR կառավարում",
    QR_MONITORING: "QR-ների մոնիտորինգ",
    MY_QR_LIST: "Իմ QR-ների ցուցակ",
    PHYSICAL_NFC_ORDERS: "Ֆիզիկական քարտերի և NFC պատվերներ",
    BULK_QR_GENERATION: "Զանգվածային QR կոդերի ստեղծում",
    IMAGE_CREATION_TOKEN: "Պատկերի ստեղծման տոկեն",
    QR_SMS: "QR SMS",
    QR_LINK: "QR հղում",
    QR_TEXT: "QR տեքստ",
    QR_LOCATION: "QR տեղակայություն / վայր",
    QR_EMAIL: "QR էլ. փոստ",
    QR_CALL: "QR զանգ",
    QR_WIFI: "QR Wi-Fi",
    VISIT_STATISTICS: "Այցելությունների վիճակագրություն",
    // Գովազդի կառավարում
    AD_MONITORING: "Գովազդի մոնիտորինգ",
    DIVAR_NEWS: "Դիվարի նորություններ",
    REAL_ESTATE_AD_SUBMISSION: "Անշարժ գույքի վահանակի գովազդի ուղարկում",
    AUTO_AD_RENEWAL: "Գովազդների ավտոմատ երկարացում",
    GRADUAL_AD_SUBMISSION: "Աստիճանական գովազդի ուղարկում",
    SMART_AD_SUBMISSION: "Խելացի գովազդի ուղարկում",
    DEFAULT_AD_REGISTRATION: "Լռելյայն գովազդի գրանցում",
    AD_ANALYZER: "Գովազդի այցելությունների անալիզատոր",
    ADD_AD_PHOTO: "Ավելացնել գովազդի լուսանկար",
    SMART_LADDER: "Խելացի սանդղակ",
    GRADUAL_LADDER: "Աստիճանական սանդղակ",
    ADS_LIST: "Գովազդների ցուցակ",
    AD_REPORTS: "Գովազդի հաշվետվություններ",
    SCHEDULED_AD_SUBMISSION: "Ժամանակացույցով գովազդի ուղարկում",
    SCHEDULED_AD_LIST: "Ժամանակացույցով գովազդների ցուցակ",
    PERSONAL_AD_SUBMISSION: "Անհատական գովազդի ուղարկում",
    TARGET_TOOLS: "Թիրախային գործիքներ",
    SMART_LIST: "Խելացի/աստիճանական ցուցակ",
    // SMS
    SEND_TO_CUSTOMER_CLUB: "Ուղարկել հաճախորդների ակումբ",
    BULK_SMS: "Զանգվածային SMS",
    LIVE_SMS: "Կենդանի SMS (հին)",
    SEND_TO_BUSINESSES: "Ուղարկել երկրի աշխատանքներին",
    SMS_BY_MAP: "SMS ուղարկել քարտեզից",
    CITY_PROVINCE_SMS: "Քաղաք և մարզ SMS",
    RECEIVED_SMS_LIST: "Ստացված SMS ցուցակ",
    SMS_TEXT_CONSULTANT: "SMS տեքստի խորհրդատուի մոնիտոր",
    DEFAULT_TEXT_CONSULTATION: "Լռելյայն տեքստ + խորհրդատվություն",
    ADMIN_SMS_SUBMISSIONS: "Ադմինի ուղարկումներ",
    PENDING_SMS: "Հաստատման սպասող SMS",
    ADMIN_RECEIVED_REPORT: "Ադմինի ստացված հաշվետվություն",
    PATTERN: "Ձևանմուշ/ձև",
    SMS_REPORTS: "Ուղարկումների հաշվետվություններ",
    DEDICATED_LINE_REQUESTS: "Նվիրված գծի հայտեր",
    PHONEBOOK: "Հեռախոսագիրք",
    SMS_TARIFFS: "SMS սակագներ",
    LINE_CATEGORIES: "Գծերի կատեգորիաներ",
    TARIFF_COEFFICIENTS: "Ուղարկման սակագնային գործակիցներ",
    SEND_ADMIN_SMS: "Ադմին SMS ուղարկել",
    // Համարներ և կոնտակտներ
    ADD_NEW_NUMBER: "Ավելացնել նոր համար",
    NUMBERS: "Համարներ",
    USER_NUMBERS: "Օգտատերերի համարներ",
    REGISTER_USER_NUMBER: "Գրանցել համար օգտատիրոջ համար",
    NUMBER_LIST: "Իմ համարների ցուցակ",
    CREATE_NUMBER_TARIFF: "Ստեղծել համարների սակագին",
    NUMBER_TARIFF_LIST: "Համարների սակագների ցուցակ",
    OTHER_TARIFF_LIST: "Այլ սակագների ցուցակ",
    // Ֆինանսական կառավարում
    WALLET: "Նոր դրամապանակ",
    TRANSFER_REQUESTS: "Հանման հայտեր",
    DIVAR_PAYMENTS: "Դիվարի վճարումներ",
    AUTO_PAYMENT: "Ավտոմատ վճարում",
    PAYMENTS: "Վճարումներ",
    PAYMENT_GATEWAY: "Վճարման դարպաս",
    BUY_CHARGE: "Գնել լիցք",
    // Հաճախորդների և օգտատերերի կառավարում
    CUSTOMERS: "Հաճախորդներ",
    CRM_CUSTOMERS: "CRM հաճախորդներ",
    CONTACT_LIST: "Կոնտակտ օգնական (շնորհակալություն կապի համար)",
    USERS: "Օգտատերերի ցուցակ",
    USER_REQUESTS: "Օգտատերերի հայտեր",
    PROFILE: "Անձնական էջ",
    USER_HISTORY_NOTIFICATIONS: "Օգտատերերի պատմության ծանուցումներ",
    // Դիզայն և բովանդակություն
    WEBSITE_DESIGN_ORDER: "Կայքի դիզայնի պատվեր",
    SEO_ORDER: "Կայքի SEO պատվեր",
    BUY_INFO_DATABASE: "Գնել տեղեկատվական բազա",
    BUY_MOBILE_DATABASE: "Գնել բջջային համարների բազա",
    PURCHASED_ARCHIVES: "Գնված արխիվներ",
    FAVORITE_ARCHIVES: "Սիրելի արխիվներ",
    UPLOAD_CENTER: "Վերբեռնման կենտրոն",
    CONTENT: "Բովանդակություն",
    // Կառավարում և կարգավորումներ
    MONITORING: "Մոնիտորինգ",
    MANAGEMENT: "Կառավարում",
    SETTINGS: "Կարգավորումներ",
    CATEGORIES: "Կատեգորիաներ",
    DOMAINS: "Դոմեններ",
    REMINDERS: "Հիշեցումներ",
    AUTOMATIC_CREATION: "Ավտոմատ ստեղծում",
    PERMISSIONS: "Թույլտվություններ",
    ROLES: "Դերեր",
    MENUS: "Մենյուներ",
    CORE_MANAGEMENT: "Հիմնական կառավարում",
    WORK_REPORTS: "Աշխատանքի հաշվետվությունների կառավարում",
    WORK_REPORT_CREATE: "Աշխատանքի հաշվետվություն",
    DEPARTMENTS: "Բաժիններ",
    DISCOUNTS: "Զեղչեր",
    NOTIFICATIONS: "Ծանուցումներ",
    ADMIN_NOTIFICATIONS: "Ադմինի ծանուցումներ",
    TICKET_MANAGEMENT: "Տոմսերի կառավարում",
    USER_GUIDE: "Օգտատիրոջ ուղեցույց",
    CAMPAIGN: "Արշավ",
    MESSAGE_CATEGORIES: "Հաղորդագրությունների կատեգորիաներ",
    REGISTERED_INFO_LIST: "Գրանցված տեղեկությունների ցուցակ",
    TARIFFS: "Սակագներ",
    INFORMATION_REGISTRATION: "Տեղեկությունների գրանցում",
    UNCREATED_CARDS: "Չստեղծված քարտեր",
    MODELS_LIST: "Մոդելների ցուցակ",
    CREATE_DEFAULT_PRODUCT: "Ստեղծել լռելյայն արտադրանք",
    EXCEL_FILES: "Excel ֆայլեր",
    AUTO_CHATS: "Խելացի չատ",
    AUTO_CHAT: "Ավտոմատ չատ",
    // سایر
    MY_FILES: "Իմ ֆայլերը",
    CONSULTANTS: "Խորհրդատուներ",
    ADD_DIVAR_NEWS: "Ավելացնել Divar-ի նորությունները",
    BUY_PANEL: "Գնել վահանակ",
    PANELS: "Վահանակներ",
    CALL_MONITORING: "Զանգերի մոնիտորինգ",
    INFO_REVIEW: "Տեղեկությունների ստուգում",
    MESSAGES: "Հաղորդագրություններ",
    PERSONNEL: "Անձնակազմ",
    //qr
    QR_TOOL: "QR գործիք",
    CREATE_DYNAMIC_QR: "Ստեղծել դինամիկ QR",
    QR_MANAGEMENT: "QR կառավարում",
    QR_MONITORING: "QR-ների մոնիտորինգ",
    MY_QR_LIST: "Իմ QR-ների ցուցակ",
    PHYSICAL_NFC_ORDERS: "Ֆիզիկական քարտերի և NFC պատվերներ",
    BULK_QR_GENERATION: "Զանգվածային QR կոդերի ստեղծում",
    IMAGE_CREATION_TOKEN: "Պատկերի ստեղծման տոկեն",
    CATEGORIES: "Կատեգորիաներ",
    CREATE_DEFAULT_PRODUCT: "Ստեղծել լռելյայն արտադրանք",
    DOMAINS: "Դոմեններ",
    REMINDERS: "Հիշեցումներ",
    AUTOMATIC_CREATION: "Ավտոմատ ստեղծում",
    SEND_ADMIN_SMS: "Ադմին SMS ուղարկել",
    UNCREATED_CARDS: "Չստեղծված քարտեր",
    MODELS_LIST: "Մոդելների ցուցակ",
    UPLOAD_CENTER: "Վերբեռնման կենտրոն",
    INFORMATION_REGISTRATION: "Տեղեկությունների գրանցում",
    TARIFFS: "Սակագներ",
    REGISTERED_INFO_LIST: "Գրանցված տեղեկությունների ցուցակ",
    //code
    personel: "Անձնակազմ",
    "workReports/create": "Աշխատանքի հաշվետվություն",
    "admin/user-guide": "Օգտատիրոջ ուղեցույց",
    phonebook: "Հաճախորդների ակումբ",
    contactlist: "Կոնտակտ օգնական (շնորհակալություն կապի համար)",
    "contact/list": "Կոնտակտ օգնական (շնորհակալություն կապի համար)",
    "admin/transferRequests": "Հանման հայտեր",
    "admin/wallet": "Նոր դրամապանակ",
    "admin/cdr": "Զանգերի մոնիտորինգ",
    "admin/campaign": "Արշավ",
    "admin/message-categories": "Հաղորդագրությունների կատեգորիաներ",
    "admin/customers": "CRM հաճախորդներ",
    "admin/notifications": "Ադմինի ծանուցումներ",
    "admin/user-history/notifications": "Օգտատերերի պատմության ծանուցումներ",
    "admin/messages": "Հաղորդագրություններ",
    profile: "Անձնական էջ",
    "admin/workReports": "Աշխատանքի հաշվետվությունների կառավարում",
    panel: "Գնել վահանակ",
    adminDiscounts: "Զեղչեր",
    departments: "Բաժիններ",
    adminTickets: "Տոմսերի կառավարում",
    "admin/configs": "Կարգավորումներ",
    notifications: "Ծանուցումներ",
    "user/confirmed": "Օգտատերերի հայտեր",
    users: "Օգտատերերի ցուցակ",
    payments: "Վճարման դարպաս",
    permission: "Թույլտվություններ",
    panels: "Վահանակներ",
    category: "Մենյուներ",
    content: "Բովանդակություն",
    role: "Դերեր",
    "core/admin": "Հիմնական կառավարում",
    //robot
    numberList: "Իմ համարների ցուցակ",
    registerAd: "Գրանցել գովազդ",
    proPanelSendAd: "Ուղարկել գովազդ պրոֆեսիոնալ վահանակով",
    buyCharge: "Գնել լիցք",
    scheduledAdSend: "Ժամանակացույցով գովազդի ուղարկում",
    smartGradual: "Խելացի/աստիճանական",
    createNumberTariff: "Ստեղծել համարների սակագին",
    numberTariffList: "Համարների սակագների ցուցակ",
    otherTariffList: "Այլ սակագների ցուցակ",
    userNumbers: "Օգտատերերի համարներ",
    numbers: "Համարներ",
    management: "Կառավարում",
    settings: "Կարգավորումներ",
    registerUserNumber: "Գրանցել համար օգտատիրոջ համար",
    divarPayments: "Divar-ի վճարումներ",
    autoPayment: "Ավտոմատ վճարում",
    adAnalyzer: "Գովազդի այցելությունների անալիզատոր",
    infoReview: "Տեղեկությունների ստուգում",
    rb_payments: "Վճարումներ",
    autoChat: "Ավտոմատ չատ",
    ads: "Գովազդներ",
    monitoring: "Մոնիտորինգ",
    smartLadder: "Խելացի սանդղակ",
    gradualLadder: "Աստիճանական սանդղակ",
    excelFiles: "Excel ֆայլեր",
    autoChats: "Խելացի չատեր",
    addAdPhoto: "Ավելացնել գովազդի լուսանկար",
    targetTools: "Թիրախային գործիքներ",
    smartList: "Խելացի/աստիճանական ցուցակ",
    scheduledAdList: "Ժամանակացույցով գովազդների ցուցակ",
    adsList: "Գովազդների ցուցակ",
    adReports: "Գովազդի հաշվետվություններ",
    personalAdSend: "Անհատական գովազդի ուղարկում",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "Մուտքագրեք ձեր ուզած ժամանակը՝",
    SUBTITLE:
      "Ժամանակը սահմանելուց հետո, այս էջը միշտ կթարմացվի ընտրված ժամանակին:",
    TIME_LABEL: "Ժամանակ",
  },
  MODAL: {
    OK_TITLE: "Հաստատել",
  },

  ROUTE: {
    TITLES: {
      "QR_NAME_EDIT_GIFT": "Խմբագրել նվերի QR կոդը",
      "QR_GIFT": "Նվերի QR կոդ",
      QR_CARD_VISIT_PRO:"Խմբագրել Pro Հղման QR",
      "QR_NAME_EDIT_PRO": "Խմբագրել Pro Հղման QR Կոդը",
      "QR_LINK_EDIT_PRO": "Խմբագրել SEO Քլիք Օգնականի QR-ը",
      "QR_LINK_PRO": "SEO Քլիք Օգնականի QR",
      DIGI: "Digikala-ի գնագոյացման մոնիտորինգ",
      QR_PDF: "PDF պատկերասրահ",
      QR_NAME_EDIT_PDF: "Խմբագրել PDF պատկերասրահը",
      QR_MULTICART: "Բազմակի QR քարտ",
      QR_MULTICART_EDIT: "Խմբագրել բազմակի QR քարտը",
      QR_PRODUCTPRO: "Ապրանքի ներկայացում (Պրո)",
      QR_NAME_PRODUCTPRO: "Խմբագրել ապրանքի ներկայացումը (Պրո)",
      QR_NAME_EDIT_CATALOG: "Խմբագրել կատալոգը",
      QR_LUCK_WHEEL_Edit: "Խմբագրել հաջողության անիվը",
      QR_LUCK_WHEEL: "Ստեղծել QR կոդ բախտի անիվի համար",
      DASHBOARD: "Վահանակ",
      ADMIN_QR_DOMAINS: "Դոմենների մոնիտորինգ",
      ADMIN_TOGETHER_TOKEN: "Տոկենների մոնիտորինգ",
      ADMIN_QR_SMS: "SMS ուղարկում",
      MENU_PROFILE_INFO: "Օգտատիրոջ տվյալներ",
      MENU_PROFILE_SETTING: "Անձնական էջի կարգավորումներ",
      MENU_PROFILE_ORDERS: "Պատվերներ",
      MENU_PROFILE_ADDRESSES: "Հասցեներ",
      QR_MONITORING: "QR մոնիտորինգ",
      QR_LIST: "Իմ QR-ների ցուցակ",
      QR_NAME_LIST: "Մասնակցության կառավարում",
      QR_GENERATE_MULTIPLE: "Զանգվածային QR կոդերի ստեղծում",
      QR_CARD_VISIT: "Այցեքարտի ստեղծում",
      HELP_INFO: "Կոճակի թեստ",
      QR_MENU: "Խանութի մենյու",
      QR_APPOINTMENT: "Նշանակում",
      QR_INSURANCE: "Առցանց ապահովագրության ստեղծում",
      QR_BPAGE: "Բիզնես էջի ստեղծում",
      QR_CPAGE: "Առևտրային/վարչական համալիրի կայքի ստեղծում",
      QR_BSHOP: "Առցանց խանութ",
      QR_NAME_EDIT_BSHOP: "Առցանց խանութի խմբագրում",
      QR_LINK_EDIT: "Հղման խմբագրում",
      QR_NAME_DESIGN: "Դիզայնի խմբագրում",
      QR_NAME_SETTING: "Կարգավորումների խմբագրում",
      QR_NAME_EDIT: "Այցեքարտի խմբագրում",
      QR_NAME_EDIT_BPAGE: "Բիզնես էջի խմբագրում",
      QR_EDIT_CPAGE: "Առևտրային/վարչական համալիրի կայքի խմբագրում",
      QR_NAME_INSURANCE: "Առցանց ապահովագրության խմբագրում",
      QR_NAME_EDIT_MENU: "Մենյուի խմբագրում",
      QR_NAME_EDIT_APPLICATION: "Հավելվածի ներկայացում",
      QR_NAME_EDIT_APPOINTMENT: "Նշանակման խմբագրում",
      QR_NAME_EDIT_PHOTO: "Լուսանկարների պատկերասրահի խմբագրում",
      QR_NAME_EDIT_VIDEO: "Տեսանյութերի պատկերասրահի խմբագրում",
      QR_NAME_EDIT_VOICE: "Ձայնային պատկերասրահի խմբագրում",
      QR_NAME_EDIT_FEEDBACK: "Հետադարձ կապի պատկերասրահի խմբագրում",
      QR_NAME_CONSULTATION_QR_EDIT: "Հայտի ձևի խմբագրում",
      QR_NAME_EDIT_VOICE_PRO: "Ձայնային պատկերասրահի խմբագրում (պրո)",
      QR_NAME_EDIT_SOCIAL: "Սոցիալական ցանցերի խմբագրում",
      QR_NAME_STATISTICS: "QR կոդի վիճակագրություն",
      QR_CATE: "Կատեգորիայի ընտրություն",
      QR_SHARE: "Համօգտագործում",
      QR_BUSINESS_SHOP: "Բիզնես/խանութ",
      QR_CO_ORGAN: "Ընկերություն/կազմակերպություն",
      QR_CONTACT: "Հաճախորդի հետ կապ",
      QR_NOTICES: "Ծանուցումներ",
      QR_OTHERS: "Այլ",
      QR_STATICS: "Ստատիկ QR",
      QR_DYNAMICS: "Դինամիկ QR",
      QR_D_BUSINESS: "Դինամիկ բիզնես QR",
      QR_D_ORGANS: "Դինամիկ կազմակերպական QR",
      QR_D_GOVERNMENT: "Դինամիկ պետական QR",
      QR_VIDEO: "Տեսանյութերի պատկերասրահ",
      QR_APPLICATION: "Հավելվածի ներկայացում",
      QR_VOICE: "Ձայնային պատկերասրահ",
      QR_VOICE_PRO: "Ձայնային պատկերասրահ (պրո)",
      QR_CONSULTATION_QR: "Հայտի ձև",
      QR_FEEDBACK: "Հետադարձ կապի պատկերասրահ",
      QR_PHOTO: "Լուսանկարների պատկերասրահ",
      QR_CATALOG: "Կատալոգ / բրոշյուր",
      QR_LOCATION: "Տեղակայության QR ստեղծում",
      QR_SOCIAL_MEDIA: "Սոցիալական ցանցի QR ստեղծում",
      QR_LINK: "Հղման ստեղծում",
      QR_TEXT: "Տեքստի ստեղծում",
      QR_MAIL: "Էլ. փոստի ստեղծում",
      QR_CALL: "Զանգ",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Կայք",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "Բիզնես էջ",
      QR_DISCOUNT: "Զեղչի էջ",
      QR_PRODUCT_SHOP: "Ապրանքի ներկայացում",
      QR_PRODUCT_LABEL: "Ապրանքի պիտակ",
      QR_GOLD_LABEL: "Ոսկու պիտակ",
      QR_PRODUCT_TEMPLATE: "Ապրանքներ",
      ADMIN_CATEGORY: "Կատեգորիաներ",
      QR_NFC_ORDERS: "NFC քարտեր՝ սպասում են հաստատման",
      QR_NAME_PRODUCT: "Ապրանքի ներկայացման խմբագրում",
      QR_NAME_LABELPRODUCT: "Ապրանքի պիտակի խմբագրում",
      QR_NAME_GOLDPRODUCT: "Ոսկու պիտակի խմբագրում",
      QR_COINS: "Կրիպտոարժույթներ",
      QR_SHOP: "Խանութի կառավարում",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Վերբեռնման կենտրոն",
      PRICING: "QR սակագներ",
      QR_CREATE_MODELS: "Այցեքարտի մոդելի ստեղծում",
      QR_CREATE_BUSINESS_MODELS: "Բիզնես էջի մոդելի ստեղծում",
      QR_CREATE_PRODUCT_MODEL: "Ապրանքի քարտի մոդելի ստեղծում",
      QR_CREATE_MENU_MODELS: "Խանութի մենյուի մոդելի ստեղծում",
      QR_CREATE_SHOP_MODEL: "Առցանց խանութի մոդելի ստեղծում",
      MODELS_LIST: "QR մոդելների տեսակներ",
      MODELS_LIST_EDIT: "Մոդելի խմբագրում",
      MODELS_LIST_MENU_EDIT: "Մենյուի մոդելի խմբագրում",
      MODELS_LIST_BMODEL_EDIT: "Առցանց խանութի մոդելի խմբագրում",
      NFC: "NFC քարտեր",
      SUBMIT_FORM: "Գրանցել բլոգեր",
      REQUEST_LIST: "Բլոգերների ցուցակ",
      PURE_DATA: "Չստեղծված այցեքարտերի ցուցակ",
      AUTO_CREATE: "Ավտոմատ QR ստեղծում",
      QR_CREATE: "QR ստեղծում",
      HISTORY_REMINDER: "Հիշեցումների մոնիտորինգ",
      BOOK: "Հիշեցումների մոնիտորինգ"
    },
  },
  qr_management: "QR կառավարում",
  router: {
    dashboard: "Վահանակ",
    contacts: "Հաճախորդների ակումբ",
    editContact: "Խմբագրել հաճախորդին",
    createContact: "Ստեղծել հաճախորդ",
    customers: "Հաճախորդների ցուցակ",
    contactList: "Կոնտակտ օգնական",
    messages: "Հաղորդագրություններ",
    messageCategories: "Հաղորդագրությունների կատեգորիաներ",
    oldTransactions: "Հին գործարքներ",
    yourTransactions: "Ձեր գործարքները",
    buyPanel: "Գնել վահանակ",
    permissions: "Թույլտվություններ",
    createPermission: "Ստեղծել թույլտվություն",
    invitations: "Իմ հրավերների ցուցակ",
    editUser: "Խմբագրել օգտատիրոջը",
    userInformation: "Դիտել օգտատիրոջ տվյալները",
    walletEdit: "Խմբագրել օգտատիրոջ դրամապանակի տվյալները",
    userHistory: "Օգտատիրոջ պատմություն",
    userNotificationsHistory: "Օգտատերերի ծանուցումների պատմություն",
    notifications: "Ծանուցումներ",
    createNotification: "Ստեղծել ծանուցում",
    editNotification: "Խմբագրել ծանուցումը",
    adminNotifications: "Ադմինի ծանուցումներ",
    yourNotifications: "Ձեր ծանուցումները",
    adminNotificationsList: "Ադմինի ծանուցումների ցուցակ",
    tickets: "Տոմսեր",
    createTicket: "Գրանցել նոր տոմս",
    editTicket: "Խմբագրել տոմսը",
    departments: "Բաժիններ",
    createDepartment: "Նոր բաժին",
    editDepartment: "Խմբագրել բաժինը",
    adminTickets: "Տոմսերի կառավարում",
    discounts: "Զեղչեր",
    createDiscount: "Ստեղծել զեղչ",
    editDiscount: "Խմբագրել զեղչը",
    workReports: "Աշխատանքի հաշվետվություն",
    createWorkReport: "Ստեղծել աշխատանքի հաշվետվություն",
    callMonitoring: "Զանգերի մոնիտորինգ",
    adminWorkReports: "Աշխատանքի հաշվետվությունների կառավարում",
    editWorkReport: "Դիտել և խմբագրել աշխատանքի հաշվետվությունը",
    packProperties: "Փաթեթի հատկություններ",
    createPackProperty: "Ստեղծել փաթեթի հատկություն",
    editPackProperty: "Խմբագրել փաթեթի հատկությունը",
    panels: "Վահանակներ",
    createPanel: "Ստեղծել վահանակ",
    editPanel: "Խմբագրել վահանակը",
    transferRequests: "Հանման հայտեր",
    editTransferRequest: "Խմբագրել հանման հայտը",
    tariffs: "Սակագներ",
    createTariff: "Ստեղծել սակագին",
    editTariff: "Խմբագրել սակագինը",
    requests: "Հայտեր",
    viewUser: "Դիտել օգտատիրոջը",
    manageTransactions: "Գործարքների կառավարում",
    viewTransaction: "Դիտել գործարքը",
    manageConfigs: "Կարգավորումների կառավարում",
    rbLandConfigs: "Robot Land կարգավորումների կառավարում",
    editConfig: "Խմբագրել կարգավորումները",
    manageUsers: "Օգտատերերի կառավարում",
    categories: "Կատեգորիաներ",
    createCategory: "Ավելացնել կատեգորիա",
    editCategory: "Խմբագրել կատեգորիան",
    content: "Բովանդակություն",
    createContent: "Ավելացնել բովանդակություն",
    editContent: "Խմբագրել բովանդակությունը",
    addUserGuide: "Ավելացնել օգտատիրոջ ուղեցույց",
    editUserGuide: "Խմբագրել օգտատիրոջ ուղեցույցը",
    roles: "Դերեր",
    editRole: "Խմբագրել դերը",
    createRole: "Ավելացնել դեր",
    permissionTitle: "Թույլտվություններ", // For cruds.permission.title
    paymentGateways: "Վճարման դարպասներ",
    editPaymentGateway: "Խմբագրել վճարման դարպասը",
    campaigns: "Արշավներ",
    createCampaign: "Ստեղծել արշավ",
    editCampaign: "Խմբագրել արշավի տվյալները",
    adminCustomers: "Հաճախորդներ",
    createCustomer: "Ստեղծել հաճախորդներ",
    editCustomerInfo: "Խմբագրել հաճախորդի տվյալները",
    referrerCustomers: "Հղող հաճախորդներ",
    customerHistory: "Հաճախորդի պատմություն",
    userProfile: "Օգտատիրոջ անձնական էջ",
    editProfile: "Խմբագրել անձնական էջը",
    inviteFriends: "Հրավիրել ընկերներին",
    personalInfo: "Անձնական տվյալներ",
    editPersonalInfo: "Խմբագրել տվյալները",
    changePassword: "Փոխել գաղտնաբառը",
    newWallet: "Նոր դրամապանակ",
  },
  ticket: {
    text: "Գրանցել տոմս",
  },
};
